import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AdvisorInfo } from '../types/advisor';
import { fetchAdvisorConfig } from '../services/advisorConfigService';

/**
 * Hook to get advisor configuration from the database.
 * Returns null when no idCustomer is in the URL or when DB has no config.
 */
export const useAdvisor = (): AdvisorInfo | null => {
  const { idCustomer } = useParams<{ idCustomer: string }>();
  const [advisor, setAdvisor] = useState<AdvisorInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!idCustomer) {
      setAdvisor(null);
      setLoading(false);
      return;
    }

    const loadAdvisorConfig = async () => {
      try {
        setLoading(true);
        const dbConfig = await fetchAdvisorConfig(idCustomer);
        if (dbConfig) {
          console.log(`[useAdvisor] Loaded config for ${idCustomer} from database`);
          setAdvisor(dbConfig);
        } else {
          console.warn(`[useAdvisor] No config found in database for ${idCustomer}`);
          setAdvisor(null);
        }
      } catch (error) {
        console.error('[useAdvisor] Error loading advisor config:', error);
        setAdvisor(null);
      } finally {
        setLoading(false);
      }
    };

    loadAdvisorConfig();
  }, [idCustomer]);

  return advisor;
};
